import { ReferenceData } from './reference-data.model';
import { HrStatus } from './hr-status';

export class Action extends ReferenceData {

  ownerId: string;
  hrStatus: HrStatus;
  employeeStatusId: { correlation: string };
  benefitStatusId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.ownerId = data.ownerId;
    this.hrStatus = data.hrStatus;
    this.employeeStatusId = data.employeeStatusId;
    this.benefitStatusId = data.benefitStatusId;
  }
}
